import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import moment from "moment";
import lscache from "lscache";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

let docDefinition = {};
let relatorio = {};
let NewPage = true;
let Line = 0;
let tipoAgenda;

export const inicializarRelatorio = () => {
  docDefinition = {
    pageOrientation: "portrait",
    pageSize: "A4",
    header: {},
    content: [],
    footer: [],
    styles: {},
  };
};

export const createPDFDetalhesAgendamento = async (
  data,
  tipoAgendamento,
  statusAgendamento
) => {
  let AgendaRetirada = process.env.rig
    ? [122, 9, 143, 121, 9, 141, 143, 145, 142].includes(data.Agend.TipoAgendId)
    : [123, 161, 121, 261].includes(data.Agend.TipoAgendId);

  let AgendaEntrada = process.env.rig
    ? [1, 6, 3, 2, 144, 8].includes(data.Agend.TipoAgendId)
    : [41, 221, 103, 287].includes(data.Agend.TipoAgendId);

  //["ECC", "ECV", "ECTA", "ECR", "ECRTA", "ECE", "ECT", "ECCM", "ECVB", "EUA"].includes(dataContainers.TipoAgendId)

  await inicializarRelatorio();
  await cabecalhoRelatorio(tipoAgendamento);
  await formatarDadosAgendamento(data, tipoAgendamento, statusAgendamento);

  if (AgendaEntrada) {
    await formatarDadosContainersEntrada(data);
  } else await formatarDadosContainersRetirada(data);

  await avisoImportante();
  //await rodapeRelatorio();
  await setEstilos();
  //pdfMake.createPdf(docDefinition).download();
  pdfMake.createPdf(docDefinition).open();

  // tiposAgendaEntrada = ["ECC", "ECV", "ECTA", "ECR", "ECRTA", "ECE", "ECT", "ECCM", "ECVB", "EUA"];
  // tiposAgendaRetirada = ["RCV", "RCDTC", "RCDICTAC", "RCDTA", "RCCRP", "RVI", "RVB", "RDVD", "SPN"];
};

export const cabecalhoRelatorio = (tipoAgendamento) => {
  docDefinition.content.push({
    text: "RESUMO AGENDAMENTO",
    style: "header_center",
  });
  docDefinition.content.push({
    text: tipoAgendamento,
    style: "subheader_center",
  });
  docDefinition.content.push({
    canvas: [
      {
        type: "line",
        x1: 0,
        y1: 5,
        x2: 535,
        y2: 5,
        lineWidth: 0.5,
      },
    ],
  });
  // docDefinition.footer = {
  //                             columns: [
  //                                 { text: 'Emissão eletrônica no site www.teconline.com.br pelo usuário - WSTSCC', style: 'footerText' }
  //                             ]
  //                         };
  Line = 4;
};

export const rodapeRelatorio = () => {
  docDefinition.footer = {
    columns: [
      {
        text:
          "Emissão eletrônica no site www.teconline.com.br pelo usuário - WSTSCC",
        style: "footerText",
      },
    ],
  };
  Line = 4;
};
export const avisoImportante = () => {
  docDefinition.content.push({
    text:
      "IMPORTANTE: Este documento serve apenas como comprovante do agendamento. A veracidade do nome do importador é de responsabilidade de quem efetuou o agendamento. Os dados informados serão revalidados no momento do atendimento do gate no terminal.",
    style: "warning",
  });
};

export const setEstilos = () => {
  docDefinition.styles = {
    header: {
      fontSize: 14,
      bold: true,
      margin: [5, 0, 0, 10],
    },
    header_center: {
      fontSize: 14,
      bold: true,
      margin: [0, 0, 0, 5],
      alignment: "center",
    },
    subheader_center: {
      fontSize: 10,
      bold: true,
      margin: [0, 0, 0, 10],
      alignment: "center",
    },
    subheader: {
      fontSize: 12,
      bold: true,
      margin: [5, 10, 0, 0],
    },
    topic: {
      fontSize: 10,
      bold: true,
      margin: [5, 10, 0, 5],
    },
    warning: {
      fontSize: 10,
      bold: true,
      margin: [5, 10, 0, 5],
      alignment: "justify",
    },
    footerText: {
      fontSize: 8,
      margin: [45, 10, 0, 5],
      alignment: "justify",
    },
    italic_note: {
      fontSize: 10,
      italics: true,
      margin: [100, 0, 100, 5],
      alignment: "center",
    },
    tableExample: {
      margin: [0, 5, 0, 15],
    },
    tableDetails: {
      margin: [0, 5, 0, 5],
      fontSize: 10,
      color: "black",
      lineHeight: 0.6,
    },
    tableHeader: {
      margin: [0, 5, 0, 5],
      fontSize: 10,
      color: "black",
    },
  };
};

export const formatarDadosAgendamento = (
  dataAgendamento,
  tipoAgendamento,
  statusAgendamento
) => {
  const nomeUsuario = lscache.get("Nome");
  const emailUsuario = lscache.get("Email");

  const formatedHour =
    dataAgendamento.Agend.HoraAgend >= 0
      ? ""
          .concat(dataAgendamento.Agend.HoraAgend)
          .padStart(2, "0")
          .concat(":00")
      : "";

  //Formatando cabeçalho
  relatorio.agendamentoHeader = [
    //Comentario mantido para efeito de testes
    [
      { text: "NÚMERO DO TICKET :", bold: true },
      { text: dataAgendamento.Agend.Id ? dataAgendamento.Agend.Id : "----" },
    ],
    [
      {
        text: `STATUS EM ${moment().format("DD/MM/YYYY HH:mm")} :`,
        bold: true,
      },
      { text: statusAgendamento ? statusAgendamento : "----" },
    ],
    [
      { text: "DATA DO AGENDAMENTO :", bold: true },
      {
        text: dataAgendamento.Agend.DatAgend
          ? moment(dataAgendamento.Agend.DatAgend).format("DD/MM/YYYY")
          : "----",
      },
    ],
    [{ text: "HORA :", bold: true }, { text: formatedHour }],
  ];

  if ("S" === dataAgendamento.Agend.FlgGold) {
    relatorio.agendamentoHeader.push([
      { text: "GOLD :", bold: true },
      { text: "SIM" },
    ]);
  }

  relatorio.dadosVeiculos = [
    [
      {
        text: "Placa: ",
        bold: true,
      },
      {
        text: dataAgendamento.Agend.PlacaCavalo
          ? dataAgendamento.Agend.PlacaCavalo
          : "",
      },
    ],
    [
      {
        text: "Placa Carreta 1: ",
        bold: true,
      },
      {
        text: dataAgendamento.Agend.PlacaCarret1
          ? dataAgendamento.Agend.PlacaCarret1
          : "",
      },
    ],
    [
      {
        text: "Placa Carreta 2: ",
        bold: true,
      },
      {
        text: dataAgendamento.Agend.PlacaCarret2
          ? dataAgendamento.Agend.PlacaCarret2
          : "",
      },
    ],
  ];

  relatorio.dadosMotorista = [
    [
      {
        text: "CNH: ",
        bold: true,
      },
      {
        text: dataAgendamento.Agend.Cnh ? dataAgendamento.Agend.Cnh : "",
      },
    ],
    [
      {
        text: "Nome: ",
        bold: true,
      },
      {
        text: dataAgendamento.Motorista.Nome
          ? dataAgendamento.Motorista.Nome
          : "",
      },
    ],
    [
      {
        text: "CPF: ",
        bold: true,
      },
      {
        text: dataAgendamento.Motorista.Cpf
          ? dataAgendamento.Motorista.Cpf
          : "",
      },
    ],
    [
      {
        text: "Categoria: ",
        bold: true,
      },
      {
        text: dataAgendamento.Motorista.CategCnh
          ? dataAgendamento.Motorista.CategCnh
          : "*****",
      },
    ],
  ];

  docDefinition.content.push({
    style: "tableHeader",
    table: {
      body: relatorio.agendamentoHeader,
    },
    layout: {
      defaultBorder: false,
    },
  });

  // docDefinition.content.push({ style: 'subheader',
  //                                     table: {
  //                                         body: [
  //                                                 [ {
  //                                                     text: 'DETALHES: ',
  //                                                     bold:true
  //                                                   },
  //                                                   {
  //                                                     qr: dataAgendamento.Agend.Id.toString(), fit: '50'
  //                                                   }
  //                                                 ]
  //                                             ]
  //                                     },
  //                                     layout: {
  //                                         defaultBorder: false,
  //                                     }
  //                             });

  // docDefinition.content.push({ text: 'DETALHES: ', style: 'subheader'});
  // docDefinition.content.push({ qr: dataAgendamento.Agend.Id.toString(), fit: '50', style: 'subheader'});

  docDefinition.content.push({
    text: "DADOS MOTORISTA/VEICULO",
    style: "topic",
  });
  docDefinition.content.push({
    style: "tableDetails",
    table: {
      body: relatorio.dadosVeiculos,
    },
    layout: {
      defaultBorder: false,
    },
  });
  docDefinition.content.push({
    style: "tableDetails",
    table: {
      body: relatorio.dadosMotorista,
    },
    layout: {
      defaultBorder: false,
    },
  });
};

export const formatarDadosContainersEntrada = async (dataContainers) => {
  if (
    dataContainers.ListaContainers &&
    dataContainers.ListaContainers.length > 0
  ) {
    //Cabecalho Containers
    docDefinition.content.push({ text: "DADOS CONTAINER", style: "topic" });

    dataContainers.ListaContainers.forEach((row, index) => {
      // Line separator
      const lineSeparator = {
        canvas: [
          {
            type: "line",
            x1: 0,
            y1: 5,
            x2: 535,
            y2: 0,
            lineWidth: 0.5,
            lineColor: "#BDBDBD",
          },
        ],
      };
      docDefinition.content.push(lineSeparator);

      //Container Header
      let tableContainerHeader = [];
      tableContainerHeader.push({
        text: "Container: ",
        bold: true,
      });
      tableContainerHeader.push({
        text: dataContainers.ListaContainers[index].CodCntr
          ? dataContainers.ListaContainers[index].CodCntr
          : "",
      });

      docDefinition.content.push({
        style: "tableDetails",
        table: {
          body: [tableContainerHeader],
        },
        layout: {
          defaultBorder: false,
        },
      });
      //CNPJ Cliente
      let tableCNPJ = [];
      tableCNPJ.push({
        text: "Cliente/CNPJ: ",
        bold: true,
      });
      tableCNPJ.push({
        text: dataContainers.ListaContainers[index].CnpjCliente
          ? `${dataContainers.ListaContainers[index].CnpjCliente} / ${dataContainers.ListaContainers[index].RazSocialCliente}`
          : "",
      });
      //Booking
      let tableBooking = [];
      tableBooking.push({
        text: "Booking: ",
        bold: true,
      });
      tableBooking.push({
        text: dataContainers.ListaContainers[index].NumBooking
          ? dataContainers.ListaContainers[index].NumBooking
          : "",
      });
      //ISO
      let tableISO = [];
      tableISO.push({
        text: "ISO: ",
        bold: true,
      });
      tableISO.push({
        text: dataContainers.ListaContainers[index].CdIso
          ? dataContainers.ListaContainers[index].CdIso
          : "",
      });
      //Categoria
      let tableCategoria = [];
      tableCategoria.push({
        text: "Categoria: ",
        bold: true,
      });
      tableCategoria.push({
        text: dataContainers.ListaContainers[index].Categoria
          ? dataContainers.ListaContainers[index].Categoria
          : "",
      });
      //Capacidade Maxima
      let tableCapacidadeMax = [];
      tableCapacidadeMax.push({
        text: "Capacidade Max: ",
        bold: true,
      });
      tableCapacidadeMax.push({
        text: dataContainers.ListaContainers[index].ValPesoMax
          ? dataContainers.ListaContainers[index].ValPesoMax
          : "",
      });
      //Peso Documental
      let tablePesoDocumental = [];
      tablePesoDocumental.push({
        text: "Peso Documental: ",
        bold: true,
      });
      tablePesoDocumental.push({
        text: dataContainers.ListaContainers[index].ValPesoDoc
          ? dataContainers.ListaContainers[index].ValPesoDoc
          : "",
      });
      //Tara
      let tableTara = [];
      tableTara.push({
        text: "Tara: ",
        bold: true,
      });
      tableTara.push({
        text: dataContainers.ListaContainers[index].ValTara
          ? dataContainers.ListaContainers[index].ValTara
          : "",
      });
      //Operação
      let tableOperacao = [];
      tableOperacao.push({
        text: "Operação: ",
        bold: true,
      });
      tableOperacao.push({
        text:
          dataContainers.ListaContainers[index].IdViagemDtPrev != null
            ? dataContainers.ListaContainers[index].IdViagemDtPrev
            : "",
      });
      //Armador
      let tableArmador = [];
      tableArmador.push({
        text: "Armador: ",
        bold: true,
      });
      tableArmador.push({
        text:
          dataContainers.ListaContainers[index].ApelidoArmador != null
            ? dataContainers.ListaContainers[index].ApelidoArmador
            : "",
      });
      //Porto
      let tablePorto = [];
      tablePorto.push({
        text: "Porto: ",
        bold: true,
      });
      tablePorto.push({
        text: dataContainers.ListaContainers[index].CdPorto
          ? dataContainers.ListaContainers[index].CdPorto
          : "",
      });
      //Destino
      let tableDestino = [];
      tableDestino.push({
        text: "Destino: ",
        bold: true,
      });
      tableDestino.push({
        text: dataContainers.ListaContainers[index].LcCdLoc
          ? dataContainers.ListaContainers[index].LcCdLoc
          : "",
      });
      //Trânsito
      let tableTransito = [];
      if (!!dataContainers.ListaContainers[index].FlgTran) {
        tableTransito.push({
          text: "Trânsito: ",
          bold: true,
        });
        tableTransito.push({
          text:
            dataContainers.ListaContainers[index].FlgTran === "N"
              ? "Não"
              : "Sim",
        });
      }

      //Tipo Mercadoria
      let tableTipoMercadoria = [];
      tableTipoMercadoria.push({
        text: "Tipo Mercadoria: ",
        bold: true,
      });
      tableTipoMercadoria.push({
        text: dataContainers.ListaContainers[index].CdTipoMerc
          ? dataContainers.ListaContainers[index].CdTipoMerc
          : "",
      });
      //UN
      let tableUN = [];
      tableUN.push({
        text: "UN: ",
        bold: true,
      });
      tableUN.push({
        text: dataContainers.ListaContainers[index].IdUn
          ? dataContainers.ListaContainers[index].IdUn
          : "",
      });
      //Temperatura
      let tableTemperatura = [];
      tableTemperatura.push({
        text: "Temperatura: ",
        bold: true,
      });
      tableTemperatura.push({
        text: dataContainers.ListaContainers[index].ValTmpIdea
          ? dataContainers.ListaContainers[index].ValTmpIdea
          : "",
      });
      //Umidade
      let tableUmidade = [];
      tableUmidade.push({
        text: "Umidade: ",
        bold: true,
      });
      tableUmidade.push({
        text: dataContainers.ListaContainers[index].ValUmid
          ? dataContainers.ListaContainers[index].ValUmid
          : "",
      });
      //Ventilação
      let tableVentilacao = [];
      tableVentilacao.push({
        text: "Ventilação: ",
        bold: true,
      });
      tableVentilacao.push({
        text: dataContainers.ListaContainers[index].ValVent
          ? dataContainers.ListaContainers[index].ValVent
          : "",
      });
      //Sobremedida Altura
      let tableAltura = [];
      tableAltura.push({
        text: "Sobremedida Altura: ",
        bold: true,
      });
      tableAltura.push({
        text: dataContainers.ListaContainers[index].OverdmsTop
          ? dataContainers.ListaContainers[index].OverdmsTop
          : "",
      });
      //Sobremedida Direita
      let tableDireita = [];
      tableDireita.push({
        text: "Sobremedida Direita: ",
        bold: true,
      });
      tableDireita.push({
        text: dataContainers.ListaContainers[index].OverdmsDir
          ? dataContainers.ListaContainers[index].OverdmsDir
          : "",
      });
      //Sobremedida Esquerda
      let tableEsquerda = [];
      tableEsquerda.push({
        text: "Sobremedida Esquerda: ",
        bold: true,
      });
      tableEsquerda.push({
        text: dataContainers.ListaContainers[index].OverdmsEsq
          ? dataContainers.ListaContainers[index].OverdmsEsq
          : "",
      });
      //Sobremedida Frente
      let tableFrente = [];
      tableFrente.push({
        text: "Sobremedida Frente: ",
        bold: true,
      });
      tableFrente.push({
        text: dataContainers.ListaContainers[index].OverdmsFre
          ? dataContainers.ListaContainers[index].OverdmsFre
          : "",
      });

      //Sobremedida Traseira
      let tableTraseira = [];
      tableTraseira.push({
        text: "Sobremedida Traseira: ",
        bold: true,
      });
      tableTraseira.push({
        text: dataContainers.ListaContainers[index].OverdmsTra
          ? dataContainers.ListaContainers[index].OverdmsTra
          : "",
      });

      //Espaço entre linhas
      let lineSpacer = [];
      lineSpacer.push({
        text: "",
        bold: true,
      });
      lineSpacer.push({
        text: "",
      });

      docDefinition.content.push({
        style: "tableDetails",
        table: {
          body: [
            tableCNPJ,
            //tableCNPJAgente,
            //tableCNPJOvacao,
            tableBooking,
            //tableCtrc,
            tableISO,
            tableCategoria,
            tableCapacidadeMax,
            //tablePesoLiquido,
            tablePesoDocumental,
            tableTara,
            tableOperacao,
            tableArmador,
            tablePorto,
            tableDestino,
            tableTransito,
            tableTipoMercadoria,
            tableUN,
            tableTemperatura,
            tableUmidade,
            tableVentilacao,
            tableAltura,
            tableDireita,
            tableEsquerda,
            tableFrente,
            tableTraseira,
            lineSpacer,
          ],
        },
        layout: {
          defaultBorder: false,
        },
      });

      //Sessão Mercadoria
      //formatarDadosMercadoria(dataContainers.ListaContainers[index]);
      //Sessão de Lacres
      formatarDadosLacres(
        dataContainers,
        dataContainers.ListaContainers[index].Id
      );
    });
  }
};

export const formatarDadosContainersRetirada = (dataContainers) => {
  if (
    dataContainers.ListaContainers &&
    dataContainers.ListaContainers.length > 0
  ) {
    let bodyTable = [];

    //Cabecalho Containers
    docDefinition.content.push({ text: "DADOS AGENDAMENTO", style: "topic" });

    dataContainers.ListaContainers.forEach((row, index) => {
      if ([121].includes(dataContainers.Agend.TipoAgendId)) {
        //Booking
        let tableDocumento = [];
        tableDocumento.push({
          text: "Booking: ",
          bold: true,
        });
        tableDocumento.push({
          text: dataContainers.ListaContainers[index].NumBooking
            ? dataContainers.ListaContainers[index].NumBooking
            : "",
        });
        bodyTable.push(tableDocumento);

        //Quantidade
        let tableQuantidade = [];
        tableQuantidade.push({
          text: "Quantidade: ",
          bold: true,
        });
        tableQuantidade.push({
          text: dataContainers.ListaContainers[index].QtdRetirada
            ? dataContainers.ListaContainers[index].QtdRetirada
            : "",
        });
        bodyTable.push(tableQuantidade);
      }
      if ([9, 122, 123].includes(dataContainers.Agend.TipoAgendId)) {
        //Documento
        let tableDocumento = [];
        tableDocumento.push({
          text: "Documento: ",
          bold: true,
        });
        if(process.env.ssa) {
          tableDocumento.push({
            text: dataContainers.ListaContainers[index].NumBooking
              ? dataContainers.ListaContainers[index].NumBooking
              : "",
          });
        } else {
          tableDocumento.push({
            text: dataContainers.ListaContainers[index].DiRetirada
              ? dataContainers.ListaContainers[index].DiRetirada
              : "",
          });
        }
        bodyTable.push(tableDocumento);
      }
      if ([142, 145].includes(dataContainers.Agend.TipoAgendId)) {
        //Armador
        let tableArmador = [];
        tableArmador.push({
          text: "Armador: ",
          bold: true,
        });
        tableArmador.push({
          text: dataContainers.ListaContainers[index].Armador.Nome
            ? dataContainers.ListaContainers[index].Armador.Nome
            : "",
        });
        bodyTable.push(tableArmador);

        //Operação
        let tableOperacao = [];
        tableOperacao.push({
          text: "Operação: ",
          bold: true,
        });
        tableOperacao.push({
          text: dataContainers.ListaContainers[index].IdViagemDtPrev
            ? dataContainers.ListaContainers[index].IdViagemDtPrev
            : "",
        });
        bodyTable.push(tableOperacao);

        //Quantidade
        let tableQuantidade = [];
        tableQuantidade.push({
          text: "Quantidade: ",
          bold: true,
        });
        tableQuantidade.push({
          text: dataContainers.ListaContainers[index].QtdRetirada
            ? dataContainers.ListaContainers[index].QtdRetirada
            : "",
        });
        bodyTable.push(tableQuantidade);

        //Tipo de Container
        let tableTipoCntr = [];
        tableTipoCntr.push({
          text: "Tipo de Container: ",
          bold: true,
        });
        tableTipoCntr.push({
          text: dataContainers.ListaContainers[index].CdTipoCntr
            ? dataContainers.ListaContainers[index].CdTipoCntr
            : "",
        });
        bodyTable.push(tableTipoCntr);
      } else if ([282].includes(dataContainers.Agend.TipoAgendId)) {
        let tableDocumento = [];
        tableDocumento.push({
          text: "Booking: ",
          bold: true,
        });
        tableDocumento.push({
          text: dataContainers.ListaContainers[index].NumBooking
            ? dataContainers.ListaContainers[index].NumBooking
            : "",
        });
        bodyTable.push(tableDocumento);

        //Tipo de Container
        let tableTipoCntr = [];
        tableTipoCntr.push({
          text: "Tipo de Container: ",
          bold: true,
        });
        tableTipoCntr.push({
          text: dataContainers.ListaContainers[index].CdTipoCntr
            ? dataContainers.ListaContainers[index].CdTipoCntr
            : "",
        });
        bodyTable.push(tableTipoCntr);

        //Quantidade
        let tableQuantidade = [];
        tableQuantidade.push({
          text: "Quantidade: ",
          bold: true,
        });
        tableQuantidade.push({
          text: dataContainers.ListaContainers[index].QtdRetirada
            ? dataContainers.ListaContainers[index].QtdRetirada
            : "",
        });
        bodyTable.push(tableQuantidade);

        //Umidade
        let tableUmidade = [];
        tableUmidade.push({
          text: "Umidade: ",
          bold: true,
        });
        tableUmidade.push({
          text: dataContainers.ListaContainers[index].ValUmid
            ? dataContainers.ListaContainers[index].ValUmid
            : "-",
        });
        bodyTable.push(tableUmidade);

        //Ventilação
        let tableVentilacao = [];
        tableVentilacao.push({
          text: "Ventilação: ",
          bold: true,
        });
        tableVentilacao.push({
          text: dataContainers.ListaContainers[index].ValVent
            ? dataContainers.ListaContainers[index].ValVent
            : "-",
        });
        bodyTable.push(tableVentilacao);

        //Temperatura
        let tableTemperatura = [];
        tableTemperatura.push({
          text: "Temperatura: ",
          bold: true,
        });
        tableTemperatura.push({
          text: dataContainers.ListaContainers[index].ValTmpIdea
            ? dataContainers.ListaContainers[index].ValTmpIdea
            : "-",
        });
        bodyTable.push(tableTemperatura);

      } 
      else if([141].includes(dataContainers.Agend.TipoAgendId)){

        //Container Header
        let tableContainerHeader = [];
        tableContainerHeader.push({
          text: "Container: ",
          bold: true,
        });
        tableContainerHeader.push({
          text: dataContainers.ListaContainers[index].CodCntr
            ? dataContainers.ListaContainers[index].CodCntr
            : "",
        });

        bodyTable.push(tableContainerHeader);

        //Cliente / Cobrar De
        let tableContainerCliente = [];
        if(dataContainers.ListaContainers[index].RazSocialDevolucao){
          tableContainerCliente.push({
            text: "Cliente/CNPJ: ",
            bold: true,
          });
          tableContainerCliente.push({
            text: dataContainers.ListaContainers[index].RazSocialDevolucao
              ? `${dataContainers.ListaContainers[index].CnpjClienteDevolucao} / ${dataContainers.ListaContainers[index].RazSocialDevolucao}` 
              : "",
          });

          bodyTable.push(tableContainerCliente);
        }

        console.log("Dados Cntr Agendamento ",dataContainers.ListaContainers[index]);


        //OS's Selecionadas
        
        if(dataContainers.ListaContainers[index].Servicos){
          let servicos = dataContainers.ListaContainers[index].Servicos;

          if(servicos.length > 0){
            servicos.map(x=>{

              let tableContainerOs = [];

              tableContainerOs.push({
                text: "Serviço selecionado: ",
                bold: true,
              });
              tableContainerOs.push({
                text: x.DescricaoServico
              });

              bodyTable.push(tableContainerOs);

            });
          }
        }
      } else if([283].includes(dataContainers.Agend.TipoAgendId)) {
        let tableDocumento = [];
        tableDocumento.push({
          text: "Booking: ",
          bold: true,
        });
        tableDocumento.push({
          text: dataContainers.ListaContainers[index].NumBooking
            ? dataContainers.ListaContainers[index].NumBooking
            : "",
        });
        bodyTable.push(tableDocumento);

        //Tipo de Container
        let tableTipoCntr = [];
        tableTipoCntr.push({
          text: "Tipo de Container: ",
          bold: true,
        });
        tableTipoCntr.push({
          text: dataContainers.ListaContainers[index].CdTipoCntr
            ? dataContainers.ListaContainers[index].CdTipoCntr
            : "",
        });
        bodyTable.push(tableTipoCntr);

        //Quantidade
        let tableQuantidade = [];
        tableQuantidade.push({
          text: "Quantidade: ",
          bold: true,
        });
        tableQuantidade.push({
          text: dataContainers.ListaContainers[index].QtdRetirada
            ? dataContainers.ListaContainers[index].QtdRetirada
            : "",
        });
        bodyTable.push(tableQuantidade);
      }
      else {
        //Container Header
        let tableContainerHeader = [];
        tableContainerHeader.push({
          text: "Container: ",
          bold: true,
        });
        tableContainerHeader.push({
          text: dataContainers.ListaContainers[index].CodCntr
            ? dataContainers.ListaContainers[index].CodCntr
            : "",
        });

        bodyTable.push(tableContainerHeader);
      }
      //Item em branco inserido para separar dados dos containers
      let tableSeparador = [];
      tableSeparador.push({
        text: "",
      });
      tableSeparador.push({
        text: "",
      });
      bodyTable.push(tableSeparador);

      docDefinition.content.push({
        style: "tableDetails",
        table: {
          body: bodyTable,
        },
        layout: {
          defaultBorder: false,
        },
      });
    });
  }
};

export const formatarDadosLacres = (dataLacres, AgendCntrId) => {
  if (dataLacres.ListaLacres && dataLacres.ListaLacres.length > 0) {
    //Cabecalho Containers
    docDefinition.content.push({ text: "DADOS LACRE", style: "topic" });

    dataLacres.ListaLacres.forEach((row, index) => {
      if (dataLacres.ListaLacres[index].AgendCntrId === AgendCntrId) {
        let tableLacres = [];
        tableLacres.push({
          text: "Tipo: ",
          bold: true,
        });
        tableLacres.push({
          text: dataLacres.ListaLacres[index].CdLacre
            ? dataLacres.ListaLacres[index].CdLacre
            : "",
        });

        tableLacres.push({
          text: "Lacre: ",
          bold: true,
        });
        tableLacres.push({
          text: dataLacres.ListaLacres[index].Lacre
            ? dataLacres.ListaLacres[index].Lacre
            : "",
        });

        docDefinition.content.push({
          style: "tableDetails",
          table: {
            body: [tableLacres],
          },
          layout: {
            defaultBorder: false,
          },
        });
      }
    });
  }
};

export const formatarDadosMercadoria = (dataMercadoria) => {
  if (dataMercadoria) {
    //Cabecalho Containers
    docDefinition.content.push({ text: "MERCADORIA", style: "topic" });

    let tableMercadoria = [];
    tableMercadoria.push({
      text: dataMercadoria.CdTipoMerc ? dataMercadoria.CdTipoMerc : "",
    });
    tableMercadoria.push({
      text: dataMercadoria.DescMerc ? dataMercadoria.DescMerc : "*****",
    });

    docDefinition.content.push({
      style: "tableDetails",
      table: {
        body: [tableMercadoria],
      },
      layout: {
        defaultBorder: false,
      },
    });
  }

  return;
};



// WEBPACK FOOTER //
// ./src/utils/pdfDetalhesAgendamento.js